import { tasksId } from "../../../types/activityTasks";
import { completeOneTask } from "../../../store/slices/menu/tunks";
import { BarStatusActivies } from "../../../components/common/BarStatusActivies";
import React, { useEffect, useState } from "react";
import ObserverEmitter, { EVENTS } from "../../../emitter/Observer";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { useGetActivitiesBySubTopic } from "../../../hooks/useGetActivitiesBySubTopic";
import { DialogBarNew } from "../../../components/common/DialogBarNew";
import { HeaderRedPresentation } from "../../../components/common/HeaderRedPresentation";
import { PanelActivities } from "../../../components/common/PanelActivities";
import { ValidationResultModal } from "../../../components/common/ValidationResultModal";
import { ButtonPlay } from "../../../components/common/ButtonPlay";
import { ButtonHome } from "../../../components/common/ButtonHome";
import { audiosAssets } from "../../../assets/audio";
import { imgsTopic4 } from "../../../assets/imgs/Tema4";
import { ButtonValidate } from "../../../components/common/ButtonValidate";
import { voicesTypeControl } from "../../../types/audioType";
import { ButtonReturn } from "../../../components/common/ButtonReturn";

const steps = {
	dialogOne: 1,
	viewActivities: 2,
	netoChatOne: 3,
	clientChatOne: 4,
	showMonitor: 5,
	netoChatTwo: 6,
	clientChatTwo: 7,
	netoChatThree: 8,
	clientChatThree: 9,
	netoChatFour: 10,
	dialogTwo: 11,
	dialogThree: 12,
	changeActivity: 13,
	winChangeActivity: 14,
	failChangeActivity: 15,
	netoChatFive: 16,
	clientChatFour: 17,
	netoChatSix: 18,
	dialogFour: 19,
}
export const Tema4SubtopicFiveActivityTwo = () => {
	const dispatch = useDispatch();
	const navigation = useNavigate();
	const { loaded, activitiesInformation } = useSelector((state) => state.menu);
	const [uiToShow, setUiToShow] = useState(1);
	const { tasksList, points } = useGetActivitiesBySubTopic(activitiesInformation[tasksId.tema4.activities.subtema5], 2);
	useEffect(() => {
		if (loaded) {
			console.log("tema 4 subtema5 activity 2");
			ObserverEmitter.emit(EVENTS.tema4.subtopicFive.initScene, 2);
			ObserverEmitter.emit(EVENTS.audiosEvents.pauseActive, true)
			ObserverEmitter.emit(EVENTS.audiosEvents.createAudioScene, audiosAssets.escenarios.selectCharacterScene)
		}
	}, [loaded]);
	ObserverEmitter.on(EVENTS.audioInitByTopic, () => {
		ObserverEmitter.emit(EVENTS.audiosEvents.createAudioVoiceButton, audiosAssets.voices.voicesGlobal.T4.sub05.sub5_act2_a01)
	})
	ObserverEmitter.on(EVENTS.tema4.subtopicFive.activityTwo.validateChangeActivity, (status) => {
		if (status) {
			setUiToShow(steps.winChangeActivity)
		} else {
			setUiToShow(steps.failChangeActivity)
		}
	})
	return (
		<>
			<>
				<ButtonPlay />
				<ButtonHome />
				{![1, 13].includes(uiToShow) && (
					<ButtonReturn callback={() => {
						ObserverEmitter.emit(EVENTS.tema4.subtopicFive.initScene, 2);
						setUiToShow(1)
					}} />
				)}
			</>
			{uiToShow === steps.dialogOne && (
				<>
					<HeaderRedPresentation name="Actividad 2: Uso de Cupones" />
					<DialogBarNew
						dialog={
							"¡Excelente! a continuación, realizarás una venta al recibir un cupón."
						}
						callback={() => {
							setUiToShow(steps.viewActivities);
							ObserverEmitter.emit(EVENTS.audiosEvents.controlVoices, voicesTypeControl.stop)
						}}
					></DialogBarNew>
				</>
			)}
			{uiToShow === steps.viewActivities && (
				<>
					<PanelActivities
						buttonText="¡Comenzar!"
						title="Subtema 5: Sinergia"
						titleActivity="Actividades por realizar:"
						points={points}
						insigniaBackground={0}
						actionButton={() => {
							setUiToShow(steps.netoChatOne);
							ObserverEmitter.emit(EVENTS.tema4.subtopicOne.activityTwo.moveCameraWithNeto);
							ObserverEmitter.emit(EVENTS.audiosEvents.createAudioVoiceButton, audiosAssets.voices.voicesGlobal.T4.sub05.sub5_act2_a02)
						}}
						activities={tasksList}
					/>
				</>
			)}
			{uiToShow === steps.netoChatOne && (
				<>	<BarStatusActivies activities={tasksList} />
					<div className="fixed z-10 bg-[#00000074] h-full w-full"></div>
					<div className="fixed z-10 h-full w-full flex justify-center items-center">
						<figure className="w-[35%]">
							<img className="mx-auto" src={imgsTopic4.netoResting} alt="Neto" />
						</figure>
					</div>
					<DialogBarNew
						name="Neto"
						dialog={
							"Me permite su código, por favor."
						}
						callback={() => {
							setUiToShow(steps.clientChatOne);
							ObserverEmitter.emit(EVENTS.audiosEvents.createAudioVoiceButton, audiosAssets.voices.voicesGlobal.T4.sub05.sub5_act2_a03)
						}}
					></DialogBarNew>
				</>
			)}
			{uiToShow === steps.clientChatOne && (
				<>
					<div className="fixed z-10 bg-[#00000074] h-full w-full"></div>
					<div className="fixed z-10 h-full w-full flex justify-center items-center">
						<figure className="w-[35%]">
							<img className="mx-auto" src={imgsTopic4.yolandaWithCoupon} alt="Yolanda" />
						</figure>
					</div>
					<DialogBarNew
						name="Yolanda"
						dialog={
							"Sí, aquí tienes."
						}
						callback={() => {
							ObserverEmitter.emit(EVENTS.tema4.subtopicThree.activityTwo.moveCameraToMonitor);
							ObserverEmitter.emit(EVENTS.tema4.subtopicThree.activityTwo.showMonitor);
							ObserverEmitter.emit(EVENTS.tema4.subtopicFive.activityTwo.img5monitor);
							ObserverEmitter.emit(EVENTS.audiosEvents.createAudioVoiceButton, audiosAssets.voices.voicesGlobal.T4.sub05.sub5_act2_a04)
							setUiToShow(steps.showMonitor);
						}}
					></DialogBarNew>
				</>
			)}
			{uiToShow === steps.showMonitor && (
				<>
					<DialogBarNew
						name="Neto"
						dialog={
							"Comenzare a marcar."
						}
						callback={() => {
							ObserverEmitter.emit(EVENTS.tema4.subtopicThree.activityTwo.hideMonitor);
							ObserverEmitter.emit(EVENTS.tema4.subtopicOne.activityTwo.moveCameraWithNeto);
							ObserverEmitter.emit(EVENTS.audiosEvents.createAudioVoiceButton, audiosAssets.voices.voicesGlobal.T4.sub05.sub5_act2_a05)
							setUiToShow(steps.netoChatTwo);
						}}
					></DialogBarNew>
				</>
			)}
			{uiToShow === steps.netoChatTwo && (
				<>
					<div className="fixed z-10 bg-[#00000074] h-full w-full"></div>
					<div className="fixed z-10 h-full w-full flex justify-center items-center">
						<figure className="w-[35%]">
							<img className="mx-auto" src={imgsTopic4.netoResting} alt="Neto" />
						</figure>
					</div>
					<DialogBarNew
						name="Neto"
						dialog={
							"Su total es de $10 pesos, ¿desea agregar algo más?"
						}
						callback={() => {
							setUiToShow(steps.clientChatTwo);
							ObserverEmitter.emit(EVENTS.audiosEvents.createAudioVoiceButton, audiosAssets.voices.voicesGlobal.T4.sub05.sub5_act2_a06)
						}}
					></DialogBarNew>
				</>
			)}
			{uiToShow === steps.clientChatTwo && (
				<>
					<div className="fixed z-10 bg-[#00000074] h-full w-full"></div>
					<div className="fixed z-10 h-full w-full flex justify-center items-center">
						<figure className="w-[35%]">
							<img className="mx-auto" src={imgsTopic4.yolanda} alt="Yolanda" />
						</figure>
					</div>
					<DialogBarNew
						name="Yolanda"
						dialog={
							"No, así esta bien."
						}
						callback={() => {
							setUiToShow(steps.netoChatThree);
							ObserverEmitter.emit(EVENTS.audiosEvents.createAudioVoiceButton, audiosAssets.voices.voicesGlobal.T4.sub05.sub5_act2_a07)
						}}
					></DialogBarNew>
				</>
			)}
			{uiToShow === steps.netoChatThree && (
				<>
					<div className="fixed z-10 bg-[#00000074] h-full w-full"></div>
					<div className="fixed z-10 h-full w-full flex justify-center items-center">
						<figure className="w-[35%]">
							<img className="mx-auto" src={imgsTopic4.netoResting} alt="Neto" />
						</figure>
					</div>
					<DialogBarNew
						name="Neto"
						dialog={
							"¿Pago en efectivo o tarjeta?"
						}
						callback={() => {
							setUiToShow(steps.clientChatThree);
							ObserverEmitter.emit(EVENTS.audiosEvents.createAudioVoiceButton, audiosAssets.voices.voicesGlobal.T4.sub05.sub5_act2_a08)
						}}
					></DialogBarNew>
				</>
			)}
			{uiToShow === steps.clientChatThree && (
				<>
					<div className="fixed z-10 bg-[#00000074] h-full w-full"></div>
					<div className="fixed z-10 h-full w-full flex justify-center items-center">
						<figure className="w-[35%]">
							<img className="mx-auto" src={imgsTopic4.yolandaWithMoney} alt="Yolanda" />
						</figure>
					</div>
					<DialogBarNew
						name="Yolanda"
						dialog={
							"Efectivo."
						}
						callback={() => {
							setUiToShow(steps.netoChatFour);
							ObserverEmitter.emit(EVENTS.audiosEvents.createAudioVoiceButton, audiosAssets.voices.voicesGlobal.T4.sub05.sub5_act2_a09)
						}}
					></DialogBarNew>
				</>
			)}
			{uiToShow === steps.netoChatFour && (
				<>
					<div className="fixed z-10 bg-[#00000074] h-full w-full"></div>
					<div className="fixed z-10 h-full w-full flex justify-center items-center">
						<figure className="w-[35%]">
							<img className="mx-auto" src={imgsTopic4.netoResting} alt="Neto" />
						</figure>
					</div>
					<DialogBarNew
						name="Neto"
						dialog={
							"Recibo $20 pesos."
						}
						callback={() => {
							setUiToShow(steps.dialogTwo);
							ObserverEmitter.emit(EVENTS.tema4.subtopicOne.activityTwo.returnToDesk);
							ObserverEmitter.emit(EVENTS.audiosEvents.createAudioVoiceButton, audiosAssets.voices.voicesGlobal.T4.sub05.sub5_act2_a10)
						}}
					></DialogBarNew>
				</>
			)}
			{uiToShow === steps.dialogTwo && (
				<>
					<DialogBarNew
						dialog={
							"De acuerdo con la información del cliente. ¿Cuál es el cambio correcto que debes entregar?."
						}
						callback={() => {
							setUiToShow(steps.dialogThree);
							ObserverEmitter.emit(EVENTS.audiosEvents.createAudioVoiceButton, audiosAssets.voices.voicesGlobal.T4.sub05.sub5_act2_a11)
						}}
					></DialogBarNew>
				</>
			)}
			{uiToShow === steps.dialogThree && (
				<>
					<HeaderRedPresentation name="Ejercicio: Entrega el cambio correcto." />
					<DialogBarNew
						dialog={
							"Da clic sobre el cambio correcto."
						}
						callback={() => {
							ObserverEmitter.emit(EVENTS.tema4.subtopicFour.activityThree.moveCameraToBillets);
							ObserverEmitter.emit(EVENTS.tema4.subtopicFour.activityThree.changebilletsTexture);
							ObserverEmitter.emit(EVENTS.tema4.subtopicFive.activityTwo.changeActivity);
							// setUiToShow(steps.winChangeActivity);
							ObserverEmitter.emit(EVENTS.audiosEvents.controlVoices, voicesTypeControl.stop)
							setUiToShow(steps.changeActivity);
						}}
					></DialogBarNew>
				</>
			)}
			{uiToShow === steps.changeActivity && (
				<>
					<ButtonValidate
						name="Responder"
						callback={() => {
							ObserverEmitter.emit(EVENTS.tema4.subtopicFive.activityTwo.respondChangeActivity)
						}}
					>
					</ButtonValidate>
				</>
			)}
			{uiToShow === steps.winChangeActivity && (
				<>
					<div className="fixed z-10 bg-[#00000074] h-full w-full"></div>
					<ValidationResultModal
						title="¡Bien hecho!"
						numberPoints={10}
						dialogModal="Entrregar el cambio adecuado refleja tu destreza en proporcionar un servicio al cliente impecable."
						buttonTxt="Continuar"
						isCorrect={true}
						action={() => {
							dispatch(
								completeOneTask({
									idActivity: 2,
									pointsWin: 10,
									subtema: tasksId.tema4.activities.subtema5,
								})
							);
							setUiToShow(steps.netoChatFive)
							ObserverEmitter.emit(EVENTS.tema4.subtopicOne.activityTwo.moveCameraWithNeto);
							ObserverEmitter.emit(EVENTS.audiosEvents.createAudioVoiceButton, audiosAssets.voices.voicesGlobal.T4.sub05.sub5_act2_a12)
						}}
					/>
				</>
			)}
			{uiToShow === steps.failChangeActivity && (
				<>
					<div className="fixed z-10 bg-[#00000074] h-full w-full"></div>
					<ValidationResultModal
						title="Respuesta incorrecta."
						numberPoints={5}
						dialogModal="Asegúrate de practicar para mejorar tus habilidades en la atención al cliente."
						buttonTxt="Continuar"
						isCorrect={false}
						action={() => {
							dispatch(
								completeOneTask({
									idActivity: 2,
									pointsWin: 5,
									subtema: tasksId.tema4.activities.subtema5,
								})
							);
							setUiToShow(steps.netoChatFive)
							ObserverEmitter.emit(EVENTS.tema4.subtopicOne.activityTwo.moveCameraWithNeto);
							ObserverEmitter.emit(EVENTS.audiosEvents.createAudioVoiceButton, audiosAssets.voices.voicesGlobal.T4.sub05.sub5_act2_a12)
						}}
					/>
				</>
			)}
			{uiToShow === steps.netoChatFive && (
				<>
					<div className="fixed z-10 bg-[#00000074] h-full w-full"></div>
					<div className="fixed z-10 h-full w-full flex justify-center items-center">
						<figure className="w-[35%]">
							<img className="mx-auto" src={imgsTopic4.netoResting} alt="Neto" />
						</figure>
					</div>
					<DialogBarNew
						name="Neto"
						dialog={
							"Entrego $10 pesos de cambio."
						}
						callback={() => {
							setUiToShow(steps.clientChatFour);
							ObserverEmitter.emit(EVENTS.audiosEvents.createAudioVoiceButton, audiosAssets.voices.voicesGlobal.T4.sub05.sub5_act2_a13)
						}}
					></DialogBarNew>
				</>
			)}
			{uiToShow === steps.clientChatFour && (
				<>
					<div className="fixed z-10 bg-[#00000074] h-full w-full"></div>
					<div className="fixed z-10 h-full w-full flex justify-center items-center">
						<figure className="w-[35%]">
							<img className="mx-auto" src={imgsTopic4.yolanda} alt="Yolanda" />
						</figure>
					</div>
					<DialogBarNew
						name="Yolanda"
						dialog={
							"Gracias, muy amable."
						}
						callback={() => {
							setUiToShow(steps.netoChatSix);
							ObserverEmitter.emit(EVENTS.audiosEvents.createAudioVoiceButton, audiosAssets.voices.voicesGlobal.T4.sub05.sub5_act2_a14)
						}}
					></DialogBarNew>
				</>
			)}
			{uiToShow === steps.netoChatSix && (
				<>
					<div className="fixed z-10 bg-[#00000074] h-full w-full"></div>
					<div className="fixed z-10 h-full w-full flex justify-center items-center">
						<figure className="w-[35%]">
							<img className="mx-auto" src={imgsTopic4.neto} alt="Neto" />
						</figure>
					</div>
					<DialogBarNew
						name="Neto"
						dialog={
							"A usted. Vuelva pronto."
						}
						callback={() => {
							setUiToShow(steps.dialogFour);
							ObserverEmitter.emit(EVENTS.tema4.subtopicOne.activityTwo.returnToDesk);
							ObserverEmitter.emit(EVENTS.audiosEvents.createAudioVoiceButton, audiosAssets.voices.voicesGlobal.T4.sub05.sub5_act2_a15)
						}}
					></DialogBarNew>
				</>
			)}
			{uiToShow === steps.dialogFour && (
				<>
					<DialogBarNew
						dialog={
							"Lo hiciste muy bien, felicidades. Y recuerda que también puedes recibir el cupón impreso."
						}
						callback={() => {
							navigation("/home4/tema4/subtema5/results");
							ObserverEmitter.emit(EVENTS.audiosEvents.controlVoices, voicesTypeControl.stop)
						}}
					></DialogBarNew>
				</>
			)}
		</>
	)
}
